import { Component, OnDestroy, OnInit } from '@angular/core';

/**
 * Check-in seating page
 */
@Component({
  selector: 'app-checkin-seating',
  templateUrl: './checkin-seating.page.html',
  styleUrls: ['./checkin-seating.page.scss'],
})
export class CheckinSeatingPage implements OnInit, OnDestroy {

  /**
   * reset
   */
  reset: boolean;

  /**
   * Constructor
   */
  constructor() { }

  ngOnInit(): void {
    this.reset = true;
  }

  ngOnDestroy(): void {
    this.reset = false;
  }

  /**
   * Before page enter.
   */
  ionViewWillEnter() {
    this.reset = true;
  }

  /**
   * Before page leave.
   */
  ionViewWillLeave() {
    this.reset = false;
  }

}
